export type NivelDeficiencia = 0 | 2 | 6 | 10;
export type NivelExposicion = 1 | 2 | 3 | 4;
export type NivelConsecuencia = 10 | 25 | 60 | 100;

export function interpretarProbabilidad(np: number): string {
  if (np >= 24) return 'Muy Alto';
  if (np >= 10) return 'Alto';
  if (np >= 6) return 'Medio';
  return 'Bajo';
}

export function interpretarRiesgo(nr: number, nd: NivelDeficiencia): { nivel: string; interpretacion: string; aceptabilidad: string } {
  if (nd === 0) {
    return { nivel: 'IV', interpretacion: 'Mantener las medidas de control existentes, pero se deberían considerar mejoras y hacer comprobaciones periódicas.', aceptabilidad: 'Aceptable' };
  }
  if (nr >= 600) return { nivel: 'I', interpretacion: 'Situación crítica. Suspender actividades hasta que el riesgo esté bajo control. Intervención urgente.', aceptabilidad: 'No Aceptable' };
  if (nr >= 150) return { nivel: 'II', interpretacion: 'Corregir y adoptar medidas de control de inmediato.', aceptabilidad: 'No Aceptable o Aceptable con control específico' };
  if (nr >= 40) return { nivel: 'III', interpretacion: 'Mejorar si es posible. Sería conveniente justificar la intervención y su rentabilidad.', aceptabilidad: 'Mejorable' };
  return { nivel: 'IV', interpretacion: 'Mantener las medidas de control existentes, pero se deberían considerar mejoras y hacer comprobaciones periódicas.', aceptabilidad: 'Aceptable' };
}

export function calcularIPER(nd: NivelDeficiencia, ne: NivelExposicion, nc: NivelConsecuencia) {
  const np = nd * ne;
  const nr = np * nc;
  const probInfo = interpretarProbabilidad(np);
  const riesgoInfo = interpretarRiesgo(nr, nd);
  return {
    nivel_probabilidad: np,
    interpretacion_probabilidad: probInfo,
    nivel_riesgo: nr,
    interpretacion_riesgo: riesgoInfo.interpretacion,
    nivel_riesgo_categoria: riesgoInfo.nivel,
    aceptabilidad: riesgoInfo.aceptabilidad,
  };
}

export const NIVELES_DEFICIENCIA = [
  { value: 0,  label: 'Bajo (No se asigna valor)', desc: 'No se ha detectado peligro o la eficacia de las medidas preventivas es alta. El riesgo está controlado.' },
  { value: 2,  label: 'Medio (2)',                 desc: 'Se han detectado peligros que pueden dar lugar a incidentes poco significativos, o la eficacia de las medidas preventivas es moderada.' },
  { value: 6,  label: 'Alto (6)',                  desc: 'Se ha(n) detectado algún(os) peligro(s) que pueden dar lugar a incidentes significativos, o la eficacia de las medidas preventivas es baja.' },
  { value: 10, label: 'Muy Alto (10)',             desc: 'Se ha(n) detectado peligro(s) que determina(n) como posible la generación de incidentes, o la eficacia de las medidas preventivas es nula o no existe.' },
];

export const NIVELES_EXPOSICION = [
  { value: 1, label: 'Esporádica (1)', desc: 'La situación de exposición se presenta de manera eventual.' },
  { value: 2, label: 'Ocasional (2)',  desc: 'La situación de exposición se presenta alguna vez durante la jornada laboral y por un periodo de tiempo corto.' },
  { value: 3, label: 'Frecuente (3)', desc: 'La situación de exposición se presenta varias veces durante la jornada laboral por tiempos cortos.' },
  { value: 4, label: 'Continua (4)',  desc: 'La situación de exposición se presenta sin interrupción o varias veces con tiempo prolongado durante la jornada laboral.' },
];

export const NIVELES_CONSECUENCIA = [
  { value: 10,  label: 'Leve (10)',                    desc: 'Lesiones o enfermedades que no requieren incapacidad.' },
  { value: 25,  label: 'Grave (25)',                   desc: 'Lesiones o enfermedades con incapacidad laboral temporal (ILT).' },
  { value: 60,  label: 'Muy Grave (60)',               desc: 'Lesiones o enfermedades graves irreparables (Incapacidad permanente parcial o invalidez).' },
  { value: 100, label: 'Mortal o Catastrófico (100)',  desc: 'Muerte(s).' },
];

export const CATEGORIAS_PELIGRO = [
  { value: 'biologico',             label: 'Biológico' },
  { value: 'fisico',                label: 'Físico' },
  { value: 'quimico',               label: 'Químico' },
  { value: 'psicosocial',           label: 'Psicosocial' },
  { value: 'biomecanico',           label: 'Ergonómico' },
  { value: 'condiciones_seguridad', label: 'Condiciones de seguridad' },
  { value: 'fenomenos_naturales',   label: 'Fenómenos naturales' },
];

export const RIESGO_COLORS: Record<string, string> = {
  'I':   '#dc2626',
  'II':  '#ea580c',
  'III': '#ca8a04',
  'IV':  '#16a34a',
};
